import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FacilitySettingsService } from './facility-settings.service';

@Component({
  selector: 'app-facility-settings',
  templateUrl: './facility-settings.component.html',
  styleUrls: ['./facility-settings.component.css']
})
export class FacilitySettingsComponent implements OnInit {
  companyId: any;
  facilityId: any;
  configuration: any = {
    // wound_assessment_report_category: "",
    // progress_note_submission_type: "",
    // wound_assessment_report_submission_type: "",
    // wound_assessment_report_name: "",
    // // edit_charge_duration: 5,
    matrix_wound_report_destination_folder : '',
    matrix_pdf_note_destination_folder : ''
    
  };
  facilitySettings: any;
  loaderId = 'app-facility-settings';

  constructor(
    private _facilitySettingsService: FacilitySettingsService,
    private _route: ActivatedRoute,
    private _loader: NgxUiLoaderService,
    private _toastr: ToastrService,
  ) {

    this.companyId = this._route.parent.parent.snapshot.params.id;
    this.facilityId = this._route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.initFacilitySettings();
  }

  initFacilitySettings() {
    this._loader.startLoader(this.loaderId);
    this._facilitySettingsService.getFacilitySettings(this.facilityId, this.companyId).subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.configuration = response.data.configuration;
          // if(!this.configuration.wound_assessment_report_name || this.configuration.wound_assessment_report_name === ""){
          //   this.configuration.wound_assessment_report_name = "Wound Assessment Report";
          // }
          if(!this.configuration.matrix_wound_report_destination_folder || this.configuration.matrix_wound_report_destination_folder === ""){
            this.configuration.matrix_wound_report_destination_folder = "Resident Notes";
          }
          if(!this.configuration.matrix_pdf_note_destination_folder || this.configuration.matrix_pdf_note_destination_folder === ""){
            this.configuration.matrix_pdf_note_destination_folder = "Resident Notes";
          }
          // if(!this.configuration.edit_charge_duration || this.configuration.edit_charge_duration === ""){
          //   this.configuration.edit_charge_duration = 5;
          // }
          this.facilitySettings = response.data;
          this._loader.stopLoader(this.loaderId);
        }
      },
      error: error => {
        console.log("err", error);
        // this._toastr.clear(infoToastr.toastId);
        this._loader.stopLoader(this.loaderId);
      }
    });
  }
  onSelectionChange() {
    this._loader.startLoader(this.loaderId);
    this._facilitySettingsService.updateFacilitySettings(this.facilitySettings._id, this.configuration).subscribe({
      next: (response: any) => {
        if (response.status === 200) {
          this.configuration = response.data.configuration;
          this.facilitySettings = response.data;
          this._loader.stopLoader(this.loaderId);
        }
      },
      error: error => {
        console.log("err", error);
        // this._toastr.clear(infoToastr.toastId);
        this._loader.stopLoader(this.loaderId);
      }
    });
  }

}
